import { render, staticRenderFns } from "./liexian.vue?vue&type=template&id=468a4718&scoped=true&"
import script from "./liexian.vue?vue&type=script&lang=js&"
export * from "./liexian.vue?vue&type=script&lang=js&"
import style0 from "./liexian.vue?vue&type=style&index=0&id=468a4718&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468a4718",
  null
  
)

export default component.exports